<template>
    <div>
        <template v-if="templatesLoading">
            <h1><div class="count-blinker"></div> skabeloner</h1>
        </template>
        <template v-else-if="templates && templates.length > 0">
            <h1>{{ templates[0].rowCount }} skabelon<template v-if="templates.length > 1">er</template></h1>
        </template>
        <template v-else>
            <h1>Ingen skabeloner</h1>
        </template>

        <div class="list-filter" v-if="activeFilters">
            <div class="list-filter-group">
                <template v-if="supplyTypes && supplyTypes.length > 1">
                    <div class="list-filter-item" v-for="supplyType in supplyTypes" :key="supplyType.sysBusinessAreaTypeId" v-if="getFilters.supplyType.includes(supplyType.sysBusinessAreaTypeId)" :class="'list-filter-item--' + supplyType.systemName">
                        <span class="list-filter-item-label">Forretningsområde:</span><span class="list-filter-item-value"><icon class="tiny-svg" :name="supplyType.systemName" />{{ supplyType.description }}</span>
                        <button class="list-filter-item-button" @click="removeSupplyTypeFilter(supplyType.sysBusinessAreaTypeId)">
                            <span class="visually-hidden">Fjern filter</span>
                            <span aria-hidden="true">&#10761;</span>
                        </button>
                    </div>
                </template>

                <div class="list-filter-item" v-if="getFilters.address">
                    <span class="list-filter-item-label">Adresse:</span><span class="list-filter-item-value">{{ getFilters.address }}</span>
                    <button class="list-filter-item-button" @click="removeAddressFilter()">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.templates.name">
                    <span class="list-filter-item-label">Skabelonnavn:</span><span class="list-filter-item-value">{{ getFilters.templates.name }}</span>
                    <button class="list-filter-item-button" @click="removeTemplateFilter('name')">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>
            </div>
        </div>

        <pagination v-show="templates && templates.length > 0 && templates[0].pageCount > 1 && !templatesLoading" :showPaging="templates && templates.length > 0 && templates[0].pageCount > 1 ? true : false" :totalPages="templates && templates.length > 0 ? templates[0].pageCount : null" :page="'templates'" :position="'right'" />
        <div v-if="templates && templates.length > 0 && !templatesLoading" class="grid-x list-sort">
            <div class="cell large-1"></div>
            <div class="cell large-3">
                <button :aria-selected="currentSort === 'name'" @click="sort('name')">Navn<icon v-if="currentSort === 'name'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'name'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-3">
                <button :aria-selected="currentSort === 'ActivityCount'" @click="sort('ActivityCount')">Antal aktiviteter<icon v-if="currentSort === 'ActivityCount'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'ActivityCount'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-2">
                <button :aria-selected="currentSort === 'OwnerUser'" @click="sort('OwnerUser')">Ansvarlig<icon v-if="currentSort === 'OwnerUser'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'OwnerUser'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-1">
                <button :aria-selected="currentSort === 'CreateRequisition'" @click="sort('CreateRequisition')">Rekvireres<icon v-if="currentSort === 'CreateRequisition'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'CreateRequisition'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-2">
                <button :aria-selected="currentSort === 'created'" @click="sort('created')">Oprettelsesdato<icon v-if="currentSort === 'created'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'created'}" name="keyboard_arrow_sort" /></button>
            </div>
        </div>
        <transition-group name="list" tag="div" v-if="!templatesLoading">
            <div class="grid-x list-row supply align-items" :class="businessAreaClass(template.businessAreaTypeId)" v-for="template in templates" :key="template.taskId">
                <div class="cell large-1">
                    <icon class="task-svg medium-svg fill-primary" name="template" />
                </div>
                <div class="cell large-3 item truncate-fade flexbox-align-items">
                    <span>{{ template.name }}</span>
                </div>
                <div class="cell large-3 item truncate-fade flexbox-align-items">
                    <span v-if="template.activities && template.activities.length > 0">{{ template.activities.length }} aktivitet<span v-if="template.activities.length > 1">er</span></span>
                    <span v-if="template.activities && template.activities.length > 0" class="templates-activities" v-for="(activity, index) in template.activities" :key="index">
                        <span class="templates-activities-seperator">|</span><span class="templates-activities-activity">{{activity}}</span>
                    </span>
                    <span v-if="!template.activities || template.activities.length < 1">Ingen aktiviteter</span>
                </div>
                <div class="cell large-2 item truncate-fade flexbox-align-items">
                    <span v-if="template.ownerUser && !template.ownerActive">{{ template.ownerUser }} (INAKTIV)</span>
                    <span v-else-if="template.ownerUser">{{ template.ownerUser }}</span>
                    <span v-else>Ingen ansvarlig</span>
                </div>
                <div class="cell large-1 item truncate-fade flexbox-align-items">
                    <span v-if="template.createRequisition">Ja</span>
                    <span v-else>Nej</span>
                </div>
                <div class="cell large-2 item truncate-fade flexbox-align-items">
                    <span v-if="template.created">{{ template.created | formatDateShortElapsed }}</span>
                    <span v-else>Ingen oprettelsesdato</span>
                </div>
                <router-link class="dashboard-list-link" :to="{ name: 'tasktemplateid', params: { id: template.taskId } }">
                    <span class="visually-hidden">Åben skabelon</span>
                </router-link>
            </div>
        </transition-group>
        <pagination v-show="templates && templates.length > 0 && templates[0].pageCount > 1 && !templatesLoading" :showPaging="templates && templates.length > 0 && templates[0].pageCount > 1 ? true : false" :totalPages="templates && templates.length > 0 ? templates[0].pageCount : null" :page="'templates'" :position="'right'" />

        <div class="dashboard-list-empty" v-if="!templatesLoading && templates && templates.length === 0">
            <template v-if="activeFilters">
                <h2>Ingen skabeloner, prøv at ændre følgende:</h2>
                <ul>
                    <li v-if="getFilters.supplyType.length < supplyTypes.length">Vælg et andet forretningsområde</li>
                </ul>
            </template>
            <template v-else>
                <p><em>Ingen skabeloner oprettet endnu...</em></p>
            </template>
        </div>

        <div class="text-center dashboard-list-loading" v-if="templatesLoading || !templates">
            Indlæser skabeloner...
            <div class="list-loader">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="visually-hidden">Indlæser...</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from './../../../components/shared/pagination/pagination.vue'

export default {
    name: 'list-templates',
    components: {
        pagination
    },
    props: {
        value: Array
    },
    data () {
        return {
            templates: this.value
        }
    },
    computed: {
        ...mapGetters({
            currentSortDir: 'getCurrentTemplateOrderByDescending',
            currentSort: 'getCurrentTemplateOrderByColumnName',

            templatesLoading: 'getTemplateLoading',

            // Filters
            supplyTypes: 'getBusinessAreaTypes',
            getFilters: 'getFilters'
        }),

        supplyTypesFormatted () {
            let formatted = ''

            this.supplyTypes.forEach((supplyType, index) => {
                if (index > 0) {
                    formatted += ', '
                }
                formatted += supplyType.description
            })

            return formatted
        },
        activeFilters () {
            if (this.supplyTypes.length > 1 || this.getFilters.address) {
                return true
            }

            return false
        }
    },
    watch: {
        value (templates) {
            this.templates = templates
        },

        getFilters: {
            deep: true,
            handler () {
                this.getFilteredList()
            }
        }
    },
    methods: {
        ...mapActions({
            getTemplates: 'getQueryTemplateList',
            setActivePages: 'setActivePages',
            removeFilters: 'removeFilters'
        }),

        sort (property) {
            let sort = this.currentSortDir
            const filterObject = {
                orderByDescending: this.currentSort !== property ? false : sort = !sort,
                orderByColumnName: property,
                tab: 'templates',
                page: 1
            }

            this.setActivePages(filterObject)
        },
        businessAreaClass (businessAreaType) {
            return this.supplyTypes.find(supplyType => supplyType.sysBusinessAreaTypeId === businessAreaType).systemName
        },
        getFilteredList () {
            const templateQuery = {}

            if (this.getFilters.supplyType) {
                templateQuery.whereBusinessAreaTypeIdList = this.getFilters.supplyType
            }

            this.getTemplates(templateQuery)
        },
        removeSupplyTypeFilter (value) {
            if (this.getFilters.supplyType.length === 1) {
                this.$notify({
                    group: 'info',
                    type: 'warn',
                    text: 'Der skal være valgt minimum et forretningsområde.',
                    duration: 7500
                })
                return
            }

            this.removeFilters({
                filter: 'supplyType',
                value: value
            })
        },
        removeAddressFilter () {
            this.removeFilters({
                filter: 'address',
                value: ''
            })
        },
        removeTemplateFilter (filter, value) {
            if (typeof this.getFilters.templates[filter] === 'string' && filter === 'name') {
                this.$parent.$children.find(child => child.$options.name === 'dashboard-filters').$refs.templateNameSearch.value = ''
            }
            this.removeFilters({
                page: 'templates',
                filter: filter,
                value: value
            })
        }
    },
    mounted () {
        this.getFilteredList()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/list/list-templates.vue